import {EntityArray} from '../../core/entityArray';
import {LookinChatSDK} from '../../lib/lookinChatSDK';
import {Message} from '../messages/message';

/**
 * Group Permission collection
 *
 * @category Group Entity
 * */
export class GroupUserPermissions extends EntityArray<string> {

  /**
   * @return if user can edit Group
   * */
  public canEditGroup() {
    return this.includes('editGroup');
  }

  /**
   * @return if user can edit Group Users
   * */
  public canEditGroupUsers() {
    return this.includes('editUser');
  }

  /**
   * @return if user can delete group
   * */
  public canDeleteGroup() {
    return this.includes('deleteGroup');
  }

  /**
   * @return if user can leave Group
   * */
  public canLeaveGroup() {
    return this.includes('leaveGroup');
  }

  /**
   * @return if user can post messages to this group
   * */
  public canPostMessage() {
    return this.includes('postMessages');
  }

  /**
   * @return if user can read messages in this group, basically this permission is access to group
   * */
  public canReadMessages() {
    return this.includes('readMessages');
  }

  /**
   * @param message, that user trying to edit
   *
   * @return if user can edit this message
   * */
  public canEditMessage(message: Message) {
    if (message.user.workerId === LookinChatSDK.user.workerId) {
      return this.includes('editSelfMessages');
    }

    return this.includes('editOtherMessages');
  }

  /**
   * @param message, that user trying to delete
   *
   * @return if user can delete this message
   * */
  public canDeleteMessage(message: Message) {
    if (message.user.workerId === LookinChatSDK.user.workerId) {
      return this.includes('deleteSelfMessages');
    }

    return this.includes('deleteOtherMessages');
  }

  /**
   * @return if user can pin messages ib this group
   * */
  public canPinMessage() {
    return this.includes('pinMessage');
  }

  /**
   * @return if user can react on messages
   * */
  public canReactMessage() {
    return this.includes('postReaction');
  }

}

export type CommonPermission =
    'readMessages'
  | 'postMessages'
  | 'editSelfMessages'
  | 'deleteSelfMessages'
  | 'postReaction'
  | 'leaveGroup';

export type CreatorPermission =
    'editGroup'
  | 'editUser'
  | 'deleteGroup'
  | 'pinMessage';
